/**
 * What a labelled figure's value is allowed to be coloured.
 *
 * Its own file, beside KeyValueList, for the reason every `*-variants.ts` in
 * this folder is: two components render these rows — KeyValueList in a card
 * and Tooltip in a hovered panel — and a second copy of this map is how they
 * would start disagreeing about what "up" looks like. The map is the contract;
 * the layout is not.
 *
 * `down` arrived with Broker Chirfaar: a hovered sector cell states its net
 * flow, and a net of −3.27 Cr printed in `neutral` would be the one number on
 * the page whose direction had been dropped.
 *
 * `accent` is chrome — a figure a control is about to act on — and never a
 * direction. Market colour means direction and nothing else; see Change.tsx.
 */
export const valueTones = {
  neutral: 'text-foreground',
  up: 'text-market-up',
  down: 'text-market-down',
  accent: 'text-accent',
} as const

export type ValueTone = keyof typeof valueTones
